export default "__VITE_ASSET__DdmlKJZF__"